import * as tslib_1 from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { Popper } from 'react-popper';
import TooltipContent from './TooltipContent/TooltipContent';
import ErrorBoundary from '../ErrorBoundary';
import s from './Tooltip.scss';
var instanceCount = 0;
var TooltipPopper = /** @class */ (function (_super) {
    tslib_1.__extends(TooltipPopper, _super);
    function TooltipPopper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portalName = "popper-root-" + instanceCount++;
        _this.renderPopper = function () {
            var _a = _this.props, isOpen = _a.isOpen, children = _a.children, placement = _a.placement, modifiers = _a.modifiers, positionFixed = _a.positionFixed, eventsEnabled = _a.eventsEnabled, referenceElement = _a.referenceElement, usePortal = _a.usePortal, renderTooltipContent = _a.renderTooltipContent, tooltipProps = tslib_1.__rest(_a, ["isOpen", "children", "placement", "modifiers", "positionFixed", "eventsEnabled", "referenceElement", "usePortal", "renderTooltipContent"]);
            var props = {
                placement: _this.getPlacement(),
                eventsEnabled: eventsEnabled,
                positionFixed: positionFixed,
            };
            // popper is moderately retarded and discards defaults if a prop is
            // passed, even if it's undefined, so gotta be careful here
            if (modifiers) {
                props.modifiers = modifiers;
            }
            if (referenceElement) {
                props.referenceElement = referenceElement;
            }
            return (React.createElement(Popper, tslib_1.__assign({}, props), function (_a) {
                var rootRef = _a.ref, scheduleUpdate = _a.scheduleUpdate, popperProps = tslib_1.__rest(_a, ["ref", "scheduleUpdate"]);
                return (React.createElement(TooltipContent, tslib_1.__assign({ rootRef: rootRef, scheduleUpdate: scheduleUpdate }, popperProps, tooltipProps),
                    React.createElement(ErrorBoundary, null, renderTooltipContent
                        ? renderTooltipContent({
                            scheduleUpdate: scheduleUpdate,
                            placement: popperProps.placement,
                        })
                        : children)));
            }));
        };
        return _this;
    }
    TooltipPopper.prototype.componentWillUnmount = function () {
        var root = this.getPortalContainer();
        root.remove();
    };
    TooltipPopper.prototype.render = function () {
        var _a = this.props, _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, usePortal = _a.usePortal;
        if (typeof document === 'undefined' || !isOpen) {
            return null;
        }
        if (usePortal) {
            return ReactDOM.createPortal(this.renderPopper(), this.getPortalContainer());
        }
        return this.renderPopper();
    };
    TooltipPopper.prototype.getPortalContainer = function () {
        var root = document.getElementById(this.portalName);
        if (!root) {
            root = document.createElement('div');
            root.id = this.portalName;
            root.className = s['portal'];
            document.body.appendChild(root);
        }
        return root;
    };
    TooltipPopper.prototype.getPlacement = function () {
        var _a = this.props.placement, placement = _a === void 0 ? 'top' : _a;
        if (placement === 'topright') {
            console.warn('Tooltip placement topright is deprecated, please update to top-end');
            return 'top-end';
        }
        return placement;
    };
    return TooltipPopper;
}(React.Component));
export { TooltipPopper };
export default TooltipPopper;
//# sourceMappingURL=TooltipPopper.js.map